import { io, Socket } from 'socket.io-client'

class SocketService {
  private socket: Socket | null = null
  private isConnected = false
  private subscribers = new Set<() => void>()

  private notifySubscribers(): void {
    this.subscribers.forEach(fn => {
      try {
        fn()
      } catch {
        // Ignore subscriber errors to avoid breaking socket lifecycle
      }
    })
  }

  public subscribe(callback: () => void): () => void {
    this.subscribers.add(callback)
    return () => {
      this.subscribers.delete(callback)
    }
  }

  public connect(): void {
    if (this.socket?.connected) {
      return
    }

    const serverUrl = process.env.REACT_APP_API_URL

    this.socket = io(serverUrl, {
      transports: ['websocket', 'polling'],
      timeout: 20000,
    })

    this.socket.on('connect', () => {
      this.isConnected = true
      this.notifySubscribers()
    })

    this.socket.on('disconnect', () => {
      this.isConnected = false
      this.notifySubscribers()
    })

    this.socket.on('connect_error', () => {
      this.isConnected = false
      this.notifySubscribers()
    })

    // Initial notify so consumers can pick up the socket instance immediately
    this.notifySubscribers()
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect()
      this.isConnected = false
      this.socket = null
      this.notifySubscribers()
    }
  }

  public isSocketConnected(): boolean {
    return this.isConnected
  }

  public getSocket(): Socket | null {
    return this.socket
  }
}

// Export singleton instance
export const socketService = new SocketService()
export default socketService
